import React, { useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import RichTextDisplay from './RichTextDisplay';

const ThemedRichTextDisplay = (props) => {
  const theme = useTheme();

  useEffect(() => {
    // Устанавливаем CSS переменные для темы
    const root = document.documentElement;
    
    root.style.setProperty('--mui-palette-text-primary', theme.palette.text.primary);
    root.style.setProperty('--mui-palette-text-secondary', theme.palette.text.secondary);
    root.style.setProperty('--mui-palette-background-paper', theme.palette.background.paper);
    root.style.setProperty('--mui-palette-background-default', theme.palette.background.default);
    root.style.setProperty('--mui-palette-primary-main', theme.palette.primary.main);
    root.style.setProperty('--mui-palette-divider', theme.palette.divider);
    root.style.setProperty('--mui-palette-action-hover', theme.palette.action.hover);
    
    // Отладочная информация для мобильных устройств
    if (process.env.NODE_ENV === 'development') {
      console.log('ThemedRichTextDisplay - Content type:', typeof props.content);
      console.log('ThemedRichTextDisplay - Content length:', props.content?.length || 0);
      console.log('ThemedRichTextDisplay - Content preview:', props.content?.substring(0, 100) || 'No content');
    }
    
  }, [theme, props.content]);

  return <RichTextDisplay {...props} />;
};

export default ThemedRichTextDisplay;
